import { CandidateRating } from '../../types';

export interface Job {
  id: string;
  title: string;
  department: string;
  location: string;
  type: 'Full-time' | 'Part-time' | 'Contract' | 'Internship';
  salary: string;
  postedDate: string;
  deadline: string;
  status: 'Open' | 'Closed' | 'Draft';
  applicants: number;
  description: string;
  requirements: string[];
}

export interface Application {
  id: string;
  jobId: string;
  candidateName: string;
  email: string;
  phone: string;
  appliedDate: string;
  status: 'Pending' | 'Reviewed' | 'Interview' | 'Hired' | 'Rejected';
  resume: string;
  rating: CandidateRating[];
  totalRating: number;
  evaluatedBy?: string;
  evaluatedAt?: string;
  notes?: string;
}

export const convertEmploymentTypeFromAPI = (type: string): Job['type'] => {
  const typeMap: Record<string, Job['type']> = {
    'full_time': 'Full-time',
    'part_time': 'Part-time',
    'contract': 'Contract',
    'temporary': 'Internship'
  };
  return typeMap[type] || 'Full-time';
};

export const convertEmploymentTypeToAPI = (type: string): string => {
  const typeMap: Record<string, string> = {
    'Full-time': 'full_time',
    'Part-time': 'part_time',
    'Contract': 'contract',
    'Internship': 'temporary'
  };
  return typeMap[type] || 'full_time';
};

export const getStatusBadge = (status: string): string => {
  const colors: Record<string, string> = {
    'Open': 'bg-green-100 text-green-800',
    'Closed': 'bg-red-100 text-red-800',
    'Draft': 'bg-yellow-100 text-yellow-800',
    'Pending': 'bg-blue-100 text-blue-800',
    'Reviewed': 'bg-purple-100 text-purple-800',
    'Interview': 'bg-orange-100 text-orange-800',
    'Hired': 'bg-green-100 text-green-800',
    'Rejected': 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};
